const uuid = (len, radix) => {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    let uuid = [], i;
    radix = radix || chars.length;
    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
      // rfc4122, version 4 form
      let r;
  
      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
  
      // Fill in random data. At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
  
    return uuid.join('')
  }
  const DEFAULT_PLUGINS = ['formschema', 'test']
  const RECORD_PLUGINS = DEFAULT_PLUGINS
  
  const getDefaultProperties = (plugins) => {
    if (!plugins || !_.isArray(plugins)) return {}
    const pp = plugins.map(p => p?.defaultProperties).filter(Boolean)
    return pp.reduce((acc, p) => {
      acc = { ...acc, ...p }
      return acc
    }, {})
  }
  
  // 分组树形结构数据处理
  const formatCatalogTree = (ary, pid,) => {
    return ary
      .filter((item) => item?.parent?.id === pid)
      .map((item) => {
        item['_isCatalog'] = true
        item['key'] = item?.id
        item['title'] = item?.name
        item.children = formatCatalogTree(ary, item.id,);
        return item;
      });
  }
  
  export {
    DEFAULT_PLUGINS, RECORD_PLUGINS, uuid,
    getDefaultProperties, formatCatalogTree
  }